import React from "react";
import { Link, withRouter } from "react-router-dom";
import { element, string, number, func, bool } from "prop-types";

import Image from "pages/_components/Image";
import Badge from "pages/_components/Badge";
import I18n from "pages/_components/I18n";
import { Mixpanel } from "util/clickstreaming";
import * as i18nUtils from "util/i18n";

class MenuItem extends React.Component {
    static propTypes = {
        title: element, // en caso de que el titulo ya venga "traducido"
        titleKey: string, // en caso de que el titulo sea una key de mensaje
        linkTo: string,
        image: string,
        onSelect: func,
        onClick: func,
        closeOnSelect: bool,
        notificationCount: number,
        notificationCountTextID: string,
        notificationNew: string,
    };

    static defaultProps = {
        title: null,
        titleKey: "",
        linkTo: "",
        image: "",
        onSelect: null,
        onClick: null,
        closeOnSelect: false,
        notificationCount: 0,
        notificationCountTextID: "",
        notificationNew: "",
    };

    onClickMenu = () => {
        const { linkTo, closeOnSelect, onSelect, titleKey } = this.props;
        const title = i18nUtils.get(titleKey);
        document.title = title.includes("Bi-Bank") ? title : "Bi-Bank - ".concat(title);
        Mixpanel.track_user("menu.action", { linkTo });
        if(typeof onSelect === "function"){
            onSelect();
        }
        if (closeOnSelect) {
            return onSelect;
        }
        return null;
    };

    getContent() {
        const {
            linkTo,
            image,
            title,
            titleKey,
            onClick: handleOnClick,
            closeOnSelect,
            onSelect,
            notificationCount,
            notificationCountTextID,
            notificationNew,
            ...rest
        } = this.props;
        let content = null;

        if (linkTo) {
            content = (
                <Link
                    role="menuitem"
                    to={linkTo}
                    className={notificationCount && "with-badge"}
                    onClick={this.onClickMenu}
                    {...rest}>
                    {image && <Image src={image} />}
                    {title || <I18n id={titleKey} />}
                    {notificationCount > 0 && (
                        <>
                            <Badge count={notificationCount} />
                            <I18n id={notificationCountTextID} componentProps={{ className: "visually-hidden" }} />
                        </>
                    )}
                    {notificationNew && 
                        <I18n id={notificationNew} componentProps={{ className: "notification-new" }}/>
                    } 
                </Link>
            );
        } else {
            content = (
                <span
                    role="button"
                    className={notificationCount && "with-badge"}
                    onClick={() => {
                        if (closeOnSelect) {
                            onSelect();
                        }
                        handleOnClick();
                    }}>
                    {image && <Image src={image} />}
                    {title || <I18n id={titleKey} />}
                </span>
            );
        }

        return content;
    }

    render() {
        return this.getContent();
    }
}

export default withRouter(MenuItem);
